import { StatCard } from "@/components/StatCard"
import { Building2, Cpu, AlertTriangle, Droplets, Gauge, Radio } from "lucide-react"
import type { AdminCouncilInfo } from "@/gen/api"

interface SuperAdminStatsSectionProps {
  councilInfos: AdminCouncilInfo[]
}

export function SuperAdminStatsSection({ councilInfos }: SuperAdminStatsSectionProps) {
  const totalCustomers = councilInfos.length
  const totalDevices = councilInfos.reduce((sum, council) => sum + (council.deviceCount || 0), 0)
  const totalActiveDevices = councilInfos.reduce(
    (sum, council) => sum + (council.activeCount || 0),
    0,
  )
  const totalAlertDevices = councilInfos.reduce(
    (sum, council) => sum + (council.alertDeviceCount || 0),
    0,
  )
  const totalOpenLeaks = councilInfos.reduce(
    (sum, council) => sum + (council.openLeakCount || 0),
    0,
  )
  const totalLeaksDetected = councilInfos.reduce(
    (sum, council) => sum + (council.leakCount || 0),
    0,
  )

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6">
      <StatCard
        title="Total Customers"
        value={totalCustomers}
        icon={Building2}
        subtitle="Active customers"
      />
      <StatCard
        title="Total Devices"
        value={totalDevices}
        icon={Cpu}
        subtitle="Smart meters & loggers"
      />
      <StatCard
        title="Active Devices"
        value={totalActiveDevices}
        icon={Gauge}
        subtitle="Currently online"
      />
      <StatCard
        title="Alert Devices"
        value={totalAlertDevices}
        icon={Radio}
        subtitle="Devices with active alarms"
      />
      <StatCard
        title="Active Leaks"
        value={totalOpenLeaks}
        icon={AlertTriangle}
        className="border-destructive/20"
        subtitle="Requires attention"
      />
      <StatCard
        title="Total Leaks Detected"
        value={totalLeaksDetected}
        icon={Droplets}
        subtitle="Leaks Detected Since Admin Portal Start"
      />
    </div>
  )
}
